import {Component, OnInit, ViewChild} from '@angular/core';
import {EnterStockrightStructureComponent} from "../enter-stockright-structure/enter-stockright-structure.component";
import {EnterpMapComponent} from "../enterp-map/enterp-map.component";
import {EnterAssociationChainGraphComponent} from "../enter-association-chain-graph/enter-association-chain-graph.component";
import {EnterActualControlPersonComponent} from "../enter-actual-control-person/enter-actual-control-person.component";
import {EnterpIntroductionServiceService} from "../../services/enterp-introduction-service.service";
import {Title} from "@angular/platform-browser";
import {HttpCommonService} from "../../services/http-common.service";
import {NzModalService} from "ng-zorro-antd";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-enterp-atlas',
  templateUrl: './enterp-atlas.component.html',
  styleUrls: ['./enterp-atlas.component.css']
})

export class EnterpAtlasComponent implements OnInit {

  @ViewChild('childMap')
  childMap: EnterpMapComponent;
  @ViewChild('childChainGraph')
  childChainGraph: EnterAssociationChainGraphComponent;
  @ViewChild('childStockRight')
  childStockRight: EnterStockrightStructureComponent;
  @ViewChild('childControlPerson')
  childControlPerson: EnterActualControlPersonComponent;

  //企业框
  @ViewChild('searchBox') searchBox;

  //控制class变量
  public active: number;

  keyword: any;

  userId: any;
  userName: any;
  fromType: any;

  constructor(private enterpIntroductionService: EnterpIntroductionServiceService,
              private titleService: Title, private httpService: HttpCommonService,
              private showAlert: NzModalService, private routerInfo: ActivatedRoute) {
    this.userId = this.routerInfo.snapshot.queryParams['userId'];
    this.userName = this.routerInfo.snapshot.queryParams['userName'];
    this.fromType = this.routerInfo.snapshot.queryParams['fromType'];

    this.enterpIntroductionService.updateTabActive(1);
    // this.active = 0;
  }

  ngOnInit() {
    this.titleService.setTitle('关联图谱-新华信用平台');
    // this.nTabs(0);
  }

  //样式改变
  nTabs(num) {
    if (!this.searchBox.company || !this.searchBox.keyWord) {
      this.showAlert.error({content: '请选择企业！', width: '300px', okText: '确认'});
      this.active = -1;
      return;
    }
    if (this.searchBox.keyWord != this.searchBox.company.companyName) {
      this.showAlert.error({content: '请正确选择企业名称！', width: '300px', okText: '确认'});
      this.active = -1;
      return;
    }
    this.keyword = this.searchBox.company.id;
    this.active = num;
    if(num == 0){
      this.childMap.companyId = this.keyword;
      setTimeout(() => this.childMap.ngAfterViewInit(),0.5);
    }else if(num == 1) {
      this.childChainGraph.companyId = this.keyword;
      setTimeout(() => this.childChainGraph.getLinkData(),0.5);
    }else if(num == 2) {
      this.childStockRight.companyId = this.keyword;
      setTimeout(() => this.childStockRight.ngAfterViewInit(),0.5);
    }else{
      setTimeout(() => this.childControlPerson.getKzrData(),0.5);
    }
    /*this.httpService.get('/enterprise/detail/xhsRest/baseMsg/getCompanyInfoByName',
      {companyName: this.keyword}).subscribe(result => {
       if (result.stateCode == '60111') {// 查询成功
         this.active = num;
         if(num == 0){
           this.childMap.companyId = result.data.returnData[0].id;
           setTimeout(() => this.childMap.ngAfterViewInit(),0.5);
         }else if(num == 1) {
           this.childChainGraph.companyId = result.data.returnData[0].id;
           setTimeout(() => this.childChainGraph.getLinkData(),0.5);
         }else if(num == 2) {
           this.childStockRight.companyId = result.data.returnData[0].id;
           setTimeout(() => this.childStockRight.ngAfterViewInit(),0.5);
         }else{
           setTimeout(() => this.childControlPerson.getKzrData(),0.5);
         }
       } else if (result.stateCode == '60100') {
         this.showAlert.error({content: '企业不存在，请稍后再试！', width: '300px', okText: '确认'});
       } else {
         this.showAlert.error({content: '查询失败，请稍后再试！', width: '300px', okText: '确认'});
       }
    });*/


  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-atlas/enterp-atlas.component.ts